import React, { useEffect } from 'react'
import Snackbar from '@mui/material/Snackbar'
import IconButton from '@mui/material/IconButton'
import SnackbarContent from '@mui/material/SnackbarContent'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

const PopupNotification = ({ message, open, handleClose }) => {
  useEffect(() => {}, [message])
  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Correct usage for positioning
    >
      <SnackbarContent
        message={message}
        sx={{ backgroundColor: '#666CFF' }} // Applying the blue background color here
        action={
          <IconButton size='small' aria-label='close' color='inherit' onClick={handleClose}>
            <Icon icon='mdi:close' fontSize={20} />
          </IconButton>
        }
      />
    </Snackbar>
  )
}

export default PopupNotification
